import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslocoService } from '@jsverse/transloco';
import { CreateDocFailedResponseDto } from 'src/app/data-transfer/entities/doc-entities/create-doc-failed-response-dto';
import { ProblemCodeDto } from 'src/app/data-transfer/entities/doc-entities/doc-problem-code-dto';
import { DialogActions } from 'src/app/model/dictionary';

export interface CreateDocFailedDialogData {
  totalCount: number;
  problemEntries: CreateDocFailedResponseDto[];
  isPackagingSystem: boolean;
  language: string;
}

@Component({
  selector: 'app-create-doc-failed-dialog',
  templateUrl: './create-doc-failed-dialog.component.html',
  styleUrls: ['./create-doc-failed-dialog.component.scss'],
})
export class CreateDocFailedDialogComponent {
  constructor(
    private dialogRef: MatDialogRef<CreateDocFailedDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CreateDocFailedDialogData,
    private translateService: TranslocoService
  ) {}

  get problemCount(): number {
    return this.data.problemEntries.length;
  }

  get validCount(): number {
    return this.data.totalCount - this.problemCount;
  }

  getProblemLabel(code: ProblemCodeDto): string {
    switch (code) {
      case ProblemCodeDto.MissingTD:
        const lang = this.translateService.translate('language.' + this.data.language);
        return `${this.translateService.translate('createDoc.failedDialog.problemCodes.missingTD')} (${lang})`;
      case ProblemCodeDto.MissingGTIN:
        return this.translateService.translate('createDoc.failedDialog.problemCodes.missingGTIN');
      case ProblemCodeDto.MissingArticleNumber:
        return this.translateService.translate('createDoc.failedDialog.problemCodes.missingArticleNumber');
      default:
        return '';
    }
  }

  onCancel() {
    this.dialogRef.close({ event: DialogActions.REJECT });
  }

  onCreateAnyway() {
    this.dialogRef.close({ event: DialogActions.CONFIRM });
  }
}
